import React from "react";
import { Outlet } from "react-router-dom";
import { HomeHeader } from "./HomeHeader";
import { HomeFooter } from "./HomeFooter";
import { HomeBookingProvider } from "./HomeBookings";
import "./home.css";
import "./home-refinement.css";
import "./home-art-direction.css";

export const HomeShell = () => <HomeBookingProvider><div className="ritual-editorial" data-testid="home-editorial-shell"><HomeHeader /><main id="home-content" tabIndex={-1}><Outlet /></main><HomeFooter /></div></HomeBookingProvider>;